import { Button, Group, Menu, Text, Tooltip } from '@mantine/core';
import { IconArrowRight, IconChevronDown, IconInbox, IconTrash } from '@tabler/icons-react';
import { useIsMobile } from '../../hooks/useIsMobile.js';
import { FloatingActionBar, FLOATING_BAR_LEFT } from '../FloatingActionBar/FloatingActionBar.js';

/** Appears only when something is ticked; the only home of collection-level writes. Push is filled, Adopt is secondary, Delete (master only) is quiet red. */
export const SelectionBar = ({
    summary,
    environments,
    onPush,
    onAdopt,
    onDelete,
    deleting = false,
    onClear,
}: {
    summary: string;
    environments: string[];
    onPush: () => void;
    onAdopt: (environment: string) => void;
    /** Deletes the selection from master, after a confirm. */
    onDelete: () => void;
    deleting?: boolean;
    onClear: () => void;
}) => {
    const isMobile = useIsMobile();
    return (
        <FloatingActionBar
            ariaLabel="Selection actions"
            left={isMobile ? 8 : FLOATING_BAR_LEFT}
            bottom={isMobile ? 'calc(8px + env(safe-area-inset-bottom))' : 16}
        >
            <Group gap="xs" wrap="wrap" justify="space-between">
                <Text fz={13} fw={500} px={4}>
                    {summary}
                </Text>
                <Group gap="xs" wrap="wrap">
                    <Tooltip label="master → environments you choose next" withArrow>
                        <Button size="sm" leftSection={<IconArrowRight size={16} stroke={1.7} />} onClick={onPush}>
                            Push to…
                        </Button>
                    </Tooltip>
                    <Menu position="top-end" withinPortal>
                        <Menu.Target>
                            <Button
                                size="sm"
                                variant="default"
                                leftSection={<IconInbox size={16} stroke={1.7} />}
                                rightSection={<IconChevronDown size={14} stroke={1.7} />}
                            >
                                Adopt from…
                            </Button>
                        </Menu.Target>
                        <Menu.Dropdown>
                            {environments.map((e) => (
                                <Menu.Item key={e} onClick={() => onAdopt(e)}>
                                    <Text className="rgs-numeric" fz="sm" span title={`${e} → master`}>
                                        {e}
                                    </Text>
                                </Menu.Item>
                            ))}
                        </Menu.Dropdown>
                    </Menu>
                    <Button
                        variant="subtle"
                        color="red"
                        size="sm"
                        leftSection={<IconTrash size={16} stroke={1.7} />}
                        loading={deleting}
                        onClick={onDelete}
                    >
                        Delete…
                    </Button>
                    <Button variant="subtle" color="gray" size="sm" onClick={onClear}>
                        Clear
                    </Button>
                </Group>
            </Group>
        </FloatingActionBar>
    );
};
